import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-geotab-page-not-accessible',
  templateUrl: './geotab-page-not-accessible.component.html',
  styleUrls: ['./geotab-page-not-accessible.component.scss'],
})
export class GeotabPageNotAccessibleComponent {
  constructor(private router: Router) {}

  public returnToHome(): void {
    this.router.navigate(['home']);
  }
}
